// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
/* eslint-disable no-new */
import Vue from 'vue'
import App from './App'
import router from './router'
import i18n from './i18n'
import VueResource from 'vue-resource'
import vueLogger from 'vue-logger'
import Storage from './api/Storage'
import VueClipboard from 'vue-clipboard2'
import Notifications from 'vue-notification'
import Scrollspy from 'vue2-scrollspy'
import vueMoment from 'vue-moment'
import moment from 'moment'
import MobileDetect from 'mobile-detect'
import VueCarousel from 'vue-carousel'
import { VueHammer } from 'vue2-hammer'

Vue.use(VueHammer)
Vue.use(VueCarousel)
Vue.use(vueMoment)

Vue.use(Scrollspy)
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: {App},
  i18n,
  moment: moment.locale(Storage.language),
  data () {
    return {
      MobileDetect: new MobileDetect(window.navigator.userAgent)
    }
  }
})

Vue.use(vueLogger, {
  prefix: 'ANALYTICS',
  dev: true,
  shortName: true,
  levels: ['log', 'warn', 'debug', 'error', 'dir']
})

Vue.use(VueResource)
Vue.http.options.root = 'https://api.analytics.leadgroup.su'
Vue.use(VueClipboard)
Vue.use(Notifications)

Vue.console.log('App init')



// WEBPACK FOOTER //
// ./src/main.js